export default __webpack_public_path__ + "static/media/5.634ffc2c.jpg";